import React, { useState } from 'react';
import './MembershipCard.css';
import Navbar from '../Navbar/Navbar';
import { members } from '../../../Redux/Slice/AuthSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const MembershipCard = () => {
  const [activePlan, setActivePlan] = useState(null);
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const plans = [
    { name: 'Starter', price: '$0', features: ['Basic Access', 'Community Forum'] },
    { name: 'Pro', price: '$29', features: ['All Access', 'Priority Support', 'Custom Tools'], popular: true },
    { name: 'Enterprise', price: '$99', features: ['Unlimited Everything', 'Dedicated Manager'] }
  ];
  const handleSub = ({name,price,id,e})=>{
    e.preventDefault()
    dispatch(members(JSON.stringify({name,price,id})))
    navigate('/portal/booking/party/checkout')
  }


  return (
    <div className='portal-kiga-question-1-main'>
      <Navbar/>
      <section className='portal-kiga-question-1-section'>
       <div className='portal-kiga-question-1-section-header'>
        <p>choose best subscription suit for you?</p>
      </div>
    <div className="container">
      {plans?.map((plan, index) => (
        <div 
          key={index}
          className={`card ${plan.popular ? 'popular' : ''} ${activePlan === index ? 'selected' : ''}`}
          onMouseEnter={() => setActivePlan(index)}
          onMouseLeave={() => setActivePlan(null)}
        >
          {plan?.popular && <span className="badge">Most Popular</span>}
          <h3>{plan?.name}</h3>
          <div className="price">{plan?.price}<span>/mo</span></div>
          <ul>
            {plan?.features?.map((f, i) => <li key={i}>{f}</li>)}
          </ul>
          <button className="btn" onClick={(e)=>handleSub({name:plan?.name,price:plan?.price,id:index,e})}>Get Started</button>
        </div>
      ))}
    </div>
    </section>
    </div>
  );
};

export default MembershipCard;